import { Component, Input, OnInit } from '@angular/core';

import { CatsRecord } from '../../../scripts/catsRecord';

@Component({
  selector: 'app-modal-content-cats-info',
  templateUrl: './modal-content-cats-info.component.html',
  standalone: false,
})
export class ModalContentCatsInfoComponent implements OnInit {
  @Input() public catsRecord!: CatsRecord;

  public records: { key: string; value: string | number | boolean }[] = [];

  ngOnInit() {
    const formattedRecords = Object.entries(this.catsRecord.getCatsFormattedRecord());
    const filteredFormattedRecords = new Map(formattedRecords.filter((fm) => fm[1]));
    const numbersOnlyPattern = /\d+/g;
    const date = new Date(Number(filteredFormattedRecords.get('Workdate').toString().match(numbersOnlyPattern))).toDateString();
    filteredFormattedRecords.set('Workdate', date);
    filteredFormattedRecords.set('Status', this.catsRecord.Status);
    this.records = Array.from(filteredFormattedRecords, ([key, value]) => ({ key, value }));
  }
}
